import { Box, Stack, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Dispatch, SetStateAction, memo, useState } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";
import { DatePickerUncontrolled, DateRangeSelect } from "@4uhub/lib4uhub";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  Status: string;
  InitialDate: Date | null;
  EndDate: Date | null;
  TasyIndividualIdentifier: string;
  SystemOriginCode: string;
  refresh?: Boolean;
}

const translationPath = "page.4uBus.logs.ipmXTasy.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const {
    // disableFilterBtn,
    filter,
    showCleanBtn,
    initialState,
    setFilter,
    cleanFilter,
  } = useFilter(filterParams);

  const { t } = useTranslation();

  const [enableFields, setEnableFields] = useState<boolean>(true);
  const [resetDateRange, setResetDateRange] = useState<boolean>(false);

  const handleStartDate = (date: Date | null) => {
    setFilter({ InitialDate: date });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ EndDate: date });
  };

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  return (
    <Stack flexDirection={"row"} gap={2}>
      <DateRangeSelect
        setEndDate={handleEndDate}
        setStartDate={handleStartDate}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.InitialDate}
          onChange={(e) => setFilter({ InitialDate: e })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.EndDate}
          onChange={(e) => setFilter({ EndDate: e })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <TextField
        value={filter.Status}
        size="small"
        label={t(translationPath + "search")}
        fullWidth
        onChange={(e) => setFilter({ Status: e.target.value })}
      />
      <TextField
        value={filter.SystemOriginCode}
        size="small"
        label={t(translationPath + "service_number_search")}
        fullWidth
        onChange={(e) => setFilter({ SystemOriginCode: e.target.value })}
      />
      <TextField
        value={filter.TasyIndividualIdentifier}
        size="small"
        label={t(translationPath + "tasy_individual_identifier")}
        fullWidth
        onChange={(e) =>
          setFilter({ TasyIndividualIdentifier: e.target.value })
        }
      />
      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        // disableFilterBtn={disableFilterBtn}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};
export default memo(MacroFilter);
